<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<div mat-dialog-content>
  <p class="wrap-white-space">{{ data.content | translate }}</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-end gap-4">
  <ng-container *ngIf="data.type === 'NOTICE'">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
      {{ data.noticeOkText ?? "DIALOG.OK" | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="data.type === 'CONFIRM'">
    <button
      mat-stroked-button
      color="primary"
      [mat-dialog-close]="false"
      cdkFocusInitial
    >
      {{ data.confirmNoText ?? "DIALOG.CANCEL" | translate }}
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      {{ data.confirmYesText ?? "DIALOG.YES" | translate }}
    </button>
  </ng-container>
</div>
